import Header from './component/header';
import './style.scss';
import { v4 as uuidv4 } from 'uuid';
window.onload = initPage;

let userName = '';
let email = '';
let subject = '';
let message = '';
let portfolioLinks = {
  jimmys: 'https://apexexp.in/Games/Jimmys/',
  trekking_run: 'https://apexexp.in/Games/TrekkingGame/',
  kfc_cricket: 'https://apexexp.in/Games/KFC/',
  heineken: 'https://apexexp.in/Games/Heineken/',
  budrush: 'https://apexexp.in/Games/BudRush/',
  bubble_shooter: 'https://apexexp.in/Games/BubbleShooter/',
  keyfactor: 'https://apexexp.in/Games/QuantumQuest/',
  mast_head: 'https://apexexp.in/Games/MastHead/',
  tke: 'https://apexexp.in/Games/TKE_2/',
  nbk: 'https://apexexp.in/Games/NBKSpinWheel/',
  tower_game: 'https://apexexp.in/Games/TowerGame/',
  ghost_float: 'https://apexexp.in/Games/GhostFloat/',
};
let videoToLoad = [
  {
    key: 'video_1',
    url: `ui/banner.mp4`,
    status: 'not_loaded',
  },
];
let videoArr = [];
function initPage() {
  fetch('/partial/header.html')
    .then((response) => response.text())
    .then((data) => {
      document.getElementById('header').innerHTML = data;
      new Header();
      preloadVideo(
        `${videoToLoad[0]['url']}?raw=true&v=1.0`,
        videoToLoad[0]['key'],
        1
      ).then(() => {
        document.querySelector('.banner_sec video').src = videoArr[0].data;
        document.querySelector('.banner_sec video').play();
      });
    })
    .catch((error) => console.error('Error loading header:', error));

  enablePortfolio();

  document.querySelector('#submitBtn').addEventListener('click', submitData);
}

function enablePortfolio() {
  document.querySelectorAll('#portfolio .card').forEach((card) => {
    card.addEventListener('click', () => {
      const gameName = card.id;
      const link = portfolioLinks[gameName];
      if (link) {
        window.open(link, '_blank');
      }
    });
  });
}

function submitData() {
  let isValid = validateRegister();

  if (isValid) {
    const data = {
      name: userName,
      email: email,
      subject: subject,
      message: message,
      uuid: uuidv4(),
    };

    const xhr = new XMLHttpRequest();
    xhr.open('POST', './contact.php', true);
    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');

    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {
        } else {
          console.error('Error:', xhr.statusText);
        }
      }
    };

    const encodedBody = window.btoa(JSON.stringify(data));
    xhr.send('data=' + encodeURIComponent(encodedBody));

    setTimeout(clearForm, 1000);
  }
}
function clearForm() {
  userName = document.querySelector('#contact #name').value.trim();
  email = document.querySelector('#contact #email').value.trim();
  subject = document.querySelector('#contact #subject').value.trim();
  message = document.querySelector('#contact #message').value.trim();

  userName = '';
  email = '';
  subject = '';
  message = '';
  document.querySelector('#contact #name').value = '';
  document.querySelector('#contact #email').value = '';
  document.querySelector('#contact #subject').value = '';
  document.querySelector('#contact #message').value = '';
  document
    .querySelector('#contact #name')
    .parentElement.classList.remove('error');
  document
    .querySelector('#contact #email')
    .parentElement.classList.remove('error');
  document
    .querySelector('#contact #subject')
    .parentElement.classList.remove('error');
  document
    .querySelector('#contact #message')
    .parentElement.classList.remove('error');

  document.querySelector('.form_info').classList.add('active');
  setTimeout(() => {
    document.querySelector('.form_info').classList.remove('active');
  }, 1500);
}
function validateRegister() {
  let isValid = true;

  userName = document.querySelector('#contact #name').value.trim();
  email = document.querySelector('#contact #email').value.trim();
  subject = document.querySelector('#contact #subject').value.trim();
  message = document.querySelector('#contact #message').value.trim();

  if (userName.length == 0) {
    document
      .querySelector('#contact #name')
      .parentElement.classList.add('error');
    isValid = false;
  } else {
    document
      .querySelector('#contact #name')
      .parentElement.classList.remove('error');
  }
  if (email.length == 0) {
    document
      .querySelector('#contact #email')
      .parentElement.classList.add('error');
    isValid = false;
  }
  if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
    document
      .querySelector('#contact #email')
      .parentElement.classList.remove('error');
  } else {
    document
      .querySelector('#contact #email')
      .parentElement.classList.add('error');
  }
  if (subject.length == 0) {
    document
      .querySelector('#contact #subject')
      .parentElement.classList.add('error');
    isValid = false;
  } else {
    document
      .querySelector('#contact #subject')
      .parentElement.classList.remove('error');
  }
  if (message.length == 0) {
    document
      .querySelector('#contact #message')
      .parentElement.classList.add('error');
    isValid = false;
  } else {
    document
      .querySelector('#contact #message')
      .parentElement.classList.remove('error');
  }

  return isValid;
}

function preloadVideo(video_url, video_key, video_index, loaderContext) {
  return new Promise((resolve, reject) => {
    const video_history = videoArr.filter((obj) => obj.key === video_key);
    if (video_history.length > 0) {
      console.log('Video already exists in array ', video_history);
      resolve(video_key);
      return;
    }

    videoArr.push({
      key: video_key,
      data: null,
      loaded: 0,
    });

    fetch(video_url)
      .then((res) => {
        if (!res.ok) {
          throw new Error(`Failed to load video: ${res.status}`);
        }
        return res.blob();
      })
      .then((blob) => {
        const video_obj = videoArr.find((obj) => obj.key === video_key);
        video_obj.data = URL.createObjectURL(blob);
        video_obj.loaded = 100;
        resolve(video_key);
      })
      .catch((err) => {
        console.log(err);
        reject(err);
      });
  });
}
